import NotFoundPage from './not_found_page';
import React        from 'react';

export default function restrictAccess(Component, check) {
  return props => {
    if (check(props))
      return <Component {...props}/>;
    else
      return <NotFoundPage/>;
  };
}
